import { FormattedMessage } from "react-intl";
import { EmptySearchContainer } from "../../ContractProducts/styles";
import { AttentionIcon } from "../Icons";

export function Empty({ intlId = "not_found_result" }) {
  return (
    <EmptySearchContainer>
      <AttentionIcon />
      <FormattedMessage id={intlId} />
    </EmptySearchContainer>
  );
}
